import React from 'react';
import Products from '../components/Products';
import SEO from '../components/SEO';

function OurProduct() {
  return (
    <>
      <SEO
        title="Our Products | Orthopaedic Implants & Instruments"
        description="Explore Sofia Surgicals' comprehensive range of orthopedic implants, trauma locking plates, interlocking nails, spine systems, and surgical instruments."
        keywords="orthopaedic products, trauma implants, locking plates, interlocking nails, spine implants, surgical tools"
        url="/Ourproduct"
      />
      <section className="implants">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="ourproduct">
                <h2 className="product">Our Products</h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Products />
    </>
  );
}

export default OurProduct;
